module.exports = __webpack_public_path__ + "static/img/R23.e3ba77c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/UltralowTemperature/R23.jpg
// module id = qq4Q
// module chunks = 1